import * as React from 'react';

import { Box, Typography } from '@mui/material';

import { useThemeContext } from 'global/ThemeContext/ThemeContext';

import type { Plugin } from '../../../hooks/useAutomationDefinitions';

type Props = {
  plugin: Plugin;
  eventType: string;
  eventName?: string;
};

/**
 * Componente genérico para condições de eventos que ainda não têm implementação específica
 * Será usado para: event_created, event_participant_added, network_edge_created, etc.
 */
export const GenericConditions: React.FC<Props> = ({ plugin, eventType, eventName }) => {
  const theme = useThemeContext();

  return (
    <Box py={2}>
      {eventName && (
        <Typography variant="body1" sx={{ color: theme.text.primary }}>
          Tipo de Evento: <strong>{eventName}</strong>
        </Typography>
      )}
      <Box
        sx={{
          p: 3,
          backgroundColor: theme.background.secondary,
          borderRadius: 1,
          textAlign: 'center',
        }}
      >
        <Typography variant="body1" sx={{ color: theme.text.secondary, mb: 1 }}>
          Condições para este tipo de evento ainda não estão disponíveis.
        </Typography>
      </Box>
    </Box>
  );
};
